<ng-template #detailed>
    <div class="meal-periods" *ngIf="mealPeriods">
        <h3 class="title">{{labels?.title}}</h3>
        <div *ngFor="let scheduleOfType of scheduleTypes">
            <div *ngFor="let mealPeriod of mealPeriodsOrder">
                <div class="meal-period" *ngIf="mealPeriods | showMealPeriod: schedules: mealPeriod: scheduleOfType">
                    <div class="meal-period-name">
                        {{ mealPeriods[mealPeriod].value }}:
                    </div>
                    <div class="meal-period-schedule">
                        <div class="schedule-type" *ngIf="scheduleOfType !== scheduleTypeOptions.operating">
                            {{ scheduleOfType }}
                        </div>
                        <div class="meal-period-item" *ngFor="let schedule of schedules[scheduleOfType][mealPeriod]">
                            <span class="meal-period-time" *ngIf="schedule.startTime !== schedule.endTime; else sameTime">
                                <span class="meal-period-name-mobile">
                                    {{ mealPeriods[mealPeriod].value }}:
                                </span>
                                {{schedule.startTime | FormatTime}}
                                {{labels.toLabel}}
                                {{schedule.endTime | FormatTime}},
                                {{schedule.priceRange}}<span class="comma">,</span>
                            </span>
                            <span class="experience-type">{{schedule.experienceType}}</span>
                            <ng-template #sameTime>
                                <span class="meal-period-time">
                                    <span class="meal-period-name-mobile">
                                        {{ mealPeriods[mealPeriod].value }}:
                                    </span>
                                    {{schedule.startTime | FormatTime}},
                                    {{schedule.priceRange}}<span class="comma">,</span>
                                </span>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #simple>
    <div class="meal-periods simple" *ngIf="mealPeriods">
        <ng-container *ngFor="let mealPeriod of mealPeriodsOrder">
            <div class="meal-period" *ngIf="mealPeriods | showMealPeriod: schedules: mealPeriod: scheduleType">
                {{mealPeriods[mealPeriod].value}} &ndash;
                <ng-container *ngFor="let schedule of schedules[scheduleType][mealPeriod]; last as last; first as first">
                    <ng-container *ngIf="schedule.startTime !== schedule.endTime; else sameTime">
                        {{schedule.startTime | FormatTime}}
                        {{labels.toLabel}}
                        {{schedule.endTime | FormatTime}}
                    </ng-container>
                    <ng-template #sameTime>
                        {{joinMealTimes(schedule.startTime | FormatTime, first, last)}}
                    </ng-template>
                </ng-container>
                {{dinnerShowTimeList}}
            </div>
        </ng-container>
    </div>
</ng-template>

<ng-container [ngSwitch]="layout">
    <ng-container *ngSwitchCase="layoutOptions.detailed">
        <ng-container *ngTemplateOutlet="detailed;"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="layoutOptions.simple">
        <ng-container *ngTemplateOutlet="simple;"></ng-container>
    </ng-container>
</ng-container>
